import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalSubliteratureSlice = createSlice({
  name: "editModalSubliterature",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalSubliteratureSlice.actions;

export default editModalSubliteratureSlice.reducer;